export const promoCodeType = {
  GET_PROMO_CODE_REQUEST: "GET_PROMO_CODE_REQUEST",
  GET_PROMO_CODE_SUCCESS: "GET_PROMO_CODE_SUCCESS",
  GET_PROMO_CODE_FAIL: "GET_PROMO_CODE_FAIL",
  UPDATE_STATUS_REQUEST: "UPDATE_STATUS_REQUEST",
  UPDATE_STATUS_SUCCESS: "UPDATE_STATUS_SUCCESS",
  UPDATE_STATUS_FAIL: "UPDATE_STATUS_FAIL",
  CREATE_PROMO_CODE_REQUEST: "CREATE_PROMO_CODE_REQUEST",
  CREATE_PROMO_CODE_SUCCESS: "CREATE_PROMO_CODE_SUCCESS",
  CREATE_PROMO_CODE_FAIL: "CREATE_PROMO_CODE_FAIL",
  UPDATE_PROMO_CODE_REQUEST: "UPDATE_PROMO_CODE_REQUEST",
  UPDATE_PROMO_CODE_SUCCESS: "UPDATE_PROMO_CODE_SUCCESS",
  UPDATE_PROMO_CODE_FAIL: "UPDATE_PROMO_CODE_FAIL",
  GET_SINGLE_PROMO_CODE_REQUEST: "GET_SINGLE_PROMO_CODE_REQUEST",
  GET_SINGLE_PROMO_CODE_SUCCESS: "GET_SINGLE_PROMO_CODE_SUCCESS",
  GET_SINGLE_PROMO_CODE_FAIL: "GET_SINGLE_PROMO_CODE_FAIL",
  GET_DISTRIBUTOR_DROPDOWN_REQUEST: "GET_DISTRIBUTOR_DROPDOWN_REQUEST",
  GET_DISTRIBUTOR_DROPDOWN_SUCCESS: "GET_DISTRIBUTOR_DROPDOWN_SUCCESS",
  GET_DISTRIBUTOR_DROPDOWN_FAIL: "GET_DISTRIBUTOR_DROPDOWN_FAIL",
  DELETE_SINGLE_PROMO_CODE_REQUEST: "DELETE_SINGLE_PROMO_CODE_REQUEST",
  DELETE_SINGLE_PROMO_CODE_SUCCESS: "DELETE_SINGLE_PROMO_CODE_SUCCESS",
  DELETE_SINGLE_PROMO_CODE_FAIL: "DELETE_SINGLE_PROMO_CODE_FAIL"
};
